module.exports = __webpack_public_path__ + "img/ирисы у зеркала 100х100.1314bddb.jpg";